import { render, staticRenderFns } from "./Logo1.vue?vue&type=template&id=71e7d576&scoped=true"
import script from "./Logo1.vue?vue&type=script&lang=js"
export * from "./Logo1.vue?vue&type=script&lang=js"
import style0 from "./Logo1.vue?vue&type=style&index=0&id=71e7d576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e7d576",
  null
  
)

export default component.exports